import React from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { LoadingButton } from "./LoadingSkeleton";

const AddRecipeForm = React.memo(({
  multiplier,
  onMultiplierChange,
  recipeOptions,
  selectedRecipeData,
  onRecipeChange,
  dayOptions,
  courseOptions,
  onDayChange,
  onCourseChange,
  onAddRecipe,
  showShoppingListConfirm,
  onShoppingListConfirmChange,
  calculateServings,
  onlyUserRecipes,
  onToggleUserRecipes,
  isLoading = false,
  currentPlanType = 'current'
}) => {
  const selectStyles = {
    option: (provided) => ({
      ...provided,
      color: "black",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
    control: (provided, state) => ({
      ...provided,
      color: "black",
      minHeight: "38px",
      backgroundColor: state.isFocused ? "white" : "rgba(255, 255, 255, 0.95)",
      borderColor: state.isFocused ? "#0d6efd" : "rgba(255, 255, 255, 0.2)",
      "&:hover": {
        borderColor: "rgba(255, 255, 255, 0.4)",
      },
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      padding: "2px 8px",
    }),
    input: (provided, state) => ({
      ...provided,
      margin: "0px",
      color: "black",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "38px",
    }),
    menu: (provided) => ({
      ...provided,
      boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)",
    }),
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">
          <i className="fas fa-utensils"></i> Add Recipe
        </h4>
        <Form.Switch
          type="switch"
          id="only-user-recipes-switch"
          label="Only Your Recipes"
          checked={onlyUserRecipes}
          onChange={onToggleUserRecipes}
        />
      </div>
      
      <div className="row g-2 align-items-end">
        <div className="col-auto">
          <label className="form-label">Multi</label>
          <input
            type="number"
            className="form-control"
            placeholder="1"
            min="0"
            value={multiplier}
            onChange={(e) => onMultiplierChange(e.target.value)}
            style={{ width: "60px" }}
          />
        </div>
        
        <div className="col">
          <div className="d-flex justify-content-between align-items-center">
            <label className="form-label">Recipe</label>
            <small className="text-light mb-1">
              Recipe makes: {calculateServings(multiplier, selectedRecipeData.servings)} servings
            </small>
          </div>
          <Select
            isSearchable={true}
            options={recipeOptions}
            value={{
              label: selectedRecipeData.label,
              value: selectedRecipeData.value,
              servings: selectedRecipeData.servings,
            }}
            onChange={onRecipeChange}
            styles={selectStyles}
            placeholder="Select a recipe..."
          />
        </div>
      </div>

      <div className="row g-2 mt-2 align-items-end">
        <div className="col">
          <label className="form-label">Day</label>
          <Select
            options={dayOptions}
            value={{
              value: selectedRecipeData.dayValue,
              label: selectedRecipeData.dayName,
            }}
            isSearchable
            onChange={onDayChange}
            styles={selectStyles}
          />
        </div>
        
        <div className="col">
          <label className="form-label">Course</label>
          <Select
            options={courseOptions}
            value={{
              value: selectedRecipeData.courseValue,
              label: selectedRecipeData.courseName,
            }}
            isSearchable
            onChange={onCourseChange}
            styles={selectStyles}
          />
        </div>
        
        <div className="col-auto">
          <LoadingButton 
            className="btn btn-primary px-3" 
            onClick={onAddRecipe}
            isLoading={isLoading}
            loadingText="Adding..."
          >
            Add Recipe
          </LoadingButton>
        </div>
      </div>
      
      {currentPlanType === 'current' && (
        <div className="mt-2">
          <Form.Check
            type="checkbox"
            id="add-to-shopping-list-check"
            label="Add to Shopping List"
            checked={showShoppingListConfirm}
            onChange={(e) => onShoppingListConfirmChange(e.target.checked)}
            className="text-light"
          />
        </div>
      )}
    </div>
  );
});

export default AddRecipeForm;